const initialState = {
    facebook: [],
    youtube: [],
    scriptreel: [],
    livereel: [],
    trimreel: [],
    syvid: [],
    sonority: [],
    videoreel: [],
    autoResponder : [],
    aiCoaches : [{
        username : "sanjay",
        created : "2013-12-04"
    }]
}

export const SocialReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ADD_SOCIAL_ACCOUNTS':
            return {
                ...state,
                facebook: action.payload.facebook,
                youtube: action.payload.youtube,
                scriptreel: action.payload.scriptreel,
                livereel: action.payload.livereel,
                trimreel: action.payload.trimreel,
                syvid: action.payload.syvid,
                sonority: action.payload.sonority,
                videoreel: action.payload.videoreel ? action.payload.videoreel : [],
                autoResponder: action.payload.autoresponder ? action.payload.autoresponder : [],
                aiCoaches: action.payload.aicoach ? action.payload.aicoach : []
            }

        case 'ADD_SYVID':
            return {
                ...state,
                syvid: action.payload
            }

        case 'REMOVE_SOCIAL_ACCOUNT':
            return {
                ...initialState
            }

        default:
            return state
    }
}